import { render, staticRenderFns } from "./tradecardform.vue?vue&type=template&id=1b8ca870&scoped=true&"
import script from "./tradecardform.vue?vue&type=script&lang=js&"
export * from "./tradecardform.vue?vue&type=script&lang=js&"
import style0 from "./tradecardform.vue?vue&type=style&index=0&id=1b8ca870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ca870",
  null
  
)

export default component.exports